const raidbotsFightStyles = {
  Patchwerk: 'Patchwerk',
  'Dungeon Slice': 'DungeonSlice',
  'Target Dummy': 'TargetDummy',
  'Execute Patchwerk': 'ExecutePatchwerk',
  'Hectic Add Cleave': 'HecticAddCleave',
  'Light Movement': 'LightMovement',
  'Heavy Movement': 'HeavyMovement',
  'Casting Patchwerk': 'CastingPatchwerk',
  'Cleave Add': 'CleaveAdd',
}

export default raidbotsFightStyles
